import React, {useEffect} from 'react';
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {get} from 'lodash';
import {
    LoadChallengeVersionAction,
    LoadedChallengeVersionAction,
    LoadChallengeResourcesAction,
    LoadedChallengeResourcesAction,
    filterConstants
} from "mindsets-js-sdk";

import useAuth from "../../hooks/useAuth";
import Resource from "./Resource";
import Banner from "./Banner";
import Top from "./Top";

import "./challenge_resources.scss";

export default function () {
    useAuth(['teacher']);

    const params = useParams();
    const dispatch = useDispatch();
    const me = useSelector(state => state.me);
    const challenge_version = useSelector(state => state.challenge_version);
    const challenge_resources = useSelector(state => state.challenge_resources);
    const curriculum_code = get(me, 'school.curriculum.code');

    function renderKeyResources() {
        return (
            <div className='section'>
                <h5>Key Resources</h5>
                <div className='flex-row flex-wrap flex-gap-10'>
                    {resources.filter(res => res.category === 'key').map((res, index) => {
                        return (
                            <Resource key={index} resource={res}/>
                        );
                    })}
                </div>
            </div>
        );
    }

    function renderOtherResources() {
        return (
            <div className='section'>
                <h5>Other Resources</h5>
                <div className='flex-row flex-wrap flex-gap-10'>
                    {resources.filter(res => res.category === 'other').map((res, index) => {
                        return (
                            <Resource key={index} resource={res}/>
                        );
                    })}
                </div>
            </div>
        );
    }

    useEffect(() => {
        dispatch(LoadChallengeVersionAction(params.challenge_code, {
            'selectors[0]': 'is_locked'
        }));
        dispatch(LoadChallengeResourcesAction({
            'filters[challenge_code][0]': filterConstants.EXPRESSION_EQUAL + '=' + params.challenge_code
        }));
        return () => {
            dispatch(LoadedChallengeResourcesAction([]))
            dispatch(LoadedChallengeVersionAction(null));
        };
    }, []);

    if (!me || !challenge_version || !challenge_resources) {
        return null;
    }

    const default_resources = [
        {
            title: "Teacher Guide",
            default: true,
            thumbnail: "dove",
            description: "Includes facilitation tips, answer key, estimated time to complete, Challenge overview.",
            url: `/resource/${challenge_version.challenge_code.code}/guide.pdf`,
            background_color: "purple",
            category: "key",
            show_for_free: true
        },
        {
            title: "Pre-Teaching Slides",
            default: false,
            thumbnail: "chalkboard-teacher",
            description: "Pre-teaching slides provide guidance on the real-world context, useful practice on the math skills and rigor to prepare students for the Challenge.",
            background_color: "purple",
            category: "key",
            show_for_free: false
        },
        {
            title: "Fast Facts",
            default: true,
            thumbnail: "rocket",
            description: "For students to get background knowledge on context, vocabulary, links to other resources.",
            url: `/resource/${challenge_version.challenge_code.code}/fact.pdf`,
            background_color: "green",
            category: "other",
            show_for_free: true
        },
        {
            title: "Answer key - main",
            default: true,
            thumbnail: "check",
            description: "For students to view answer key after completing the main part of Challenge; teacher can toggle “Show Answer Keys” on or off.",
            url: `/resource/${challenge_version.challenge_code.code}/answer-key.pdf`,
            background_color: "green",
            category: "other",
            show_for_free: true
        },
        {
            title: "Answer key - bonus",
            default: true,
            thumbnail: "check-double",
            description: "For students to view answer keys after completing the bonus section of Challenge; teacher can toggle “Show Answer Keys” on or off.",
            url: `/resource/${challenge_version.challenge_code.code}/answer-key-bonus.pdf`,
            background_color: "green",
            category: "other",
            show_for_free: true
        },
        {
            title: "ELA/ELD Extension",
            default: false,
            thumbnail: "puzzle-piece",
            description: "Teacher guide to support students with strategies to collaborate, effectively communicate and develop language skills: grammar, phonics, writing, speaking & listening supports.",
            url: `/resource/${challenge_version.challenge_code.code}/ela-eld-extension.pdf`,
            background_color: "purple",
            category: "key",
            show_for_free: false
        },
        {
            title: "Project Extension",
            default: false,
            thumbnail: "box-open",
            description: "Hands-on project-based extensions; includes teacher and student instructions.",
            url: `/resource/${challenge_version.challenge_code.code}/project-extension.pdf`,
            background_color: "purple",
            category: "key",
            show_for_free: false
        },
        {
            title: "Family Flyer",
            default: false,
            thumbnail: "list-alt",
            description: "1-page description of Challenge for students and families.",
            url: `/resource/${challenge_version.challenge_code.code}/family-flyer.pdf`,
            background_color: "green",
            category: "other",
            show_for_free: true
        }
    ];
    let resources = [];
    default_resources.map(default_resource => {
        const resource = challenge_resources.find(res => res.title === default_resource.title);

        if (!default_resource.default) {
            if (!resource) {
                return false;
            }
            if (Array.isArray(resource.curricula) && resource.curricula.length > 0) {
                if (!resource.curricula.includes(curriculum_code)) {
                    return false;
                }
            }
        }

        resources.push({
            category: default_resource.category,
            title: resource && resource.title ? resource.title : default_resource.title,
            url: default_resource.url ? default_resource.url : (resource && resource.url ? resource.url : ''),
            background_color: resource && resource.background_color ? resource.background_color : default_resource.background_color,
            thumbnail: resource && resource.thumbnail ? resource.thumbnail : default_resource.thumbnail,
            description: resource && resource.description ? resource.description : default_resource.description,
            links: resource && resource.links ? resource.links : default_resource.links,
            show_for_free: resource && resource.show_for_free ? resource.show_for_free : default_resource.show_for_free,
        });
    });
    console.log('challenge_resources', challenge_resources);

    return (
        <div id="challenge-preview">
            <div id="challenge-preview-page" className='challenge-resources'>
                <Top/>
                <div className="container">
                    <Banner/>
                    <div className="challenge-preview-info">
                        {renderKeyResources()}
                        {renderOtherResources()}
                    </div>
                </div>
            </div>
        </div>
    );
}
